/**
 * 描述：共享稿库左侧
 * 日期：2017-8-21
 * 作者: Bai.Zhiming
 */
"use strict";
angular.module("publiMaterialLibraryLeftModule", [])
    .directive("publiMaterialLibraryLeft", ["$state", "$q", "$timeout", "$stateParams", "trsHttpService", "resourceCenterService", function($state, $q, $timeout, $stateParams, trsHttpService, resourceCenterService) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                classify: "=",
            },
            templateUrl: "./resourceCenter/publicMaterialLibrary/left/left_tpl.html",
            link: function(scope, $attr, $elem) {
                initStatus();
                initData();
                /**
                 * [expandClassify description]
                 * @param {object} [classify] [description] 所选分类
                 * @return {[type]} [description]
                 */
                scope.expandClassify = function(classify) {
                    classify.isOpen = !classify.isOpen;
                };
                /**
                 * [selectItem description] 选择子分类
                 * @param {object} [item] [description] 子分类
                 * @return {[type]} [description]
                 */
                function selectItem($event, item, classify) {
                    if ($event.stopPropagation) $event.stopPropagation();
                    var nodeId, url;
                    nodeId = item.ID;
                    scope.status.parentNode = classify;
                    url = "front.resourcectrl.materials.resource";
                    var isUgc = "0";
                    if (angular.isDefined(classify.ISUGC) && classify.ISUGC == "1") {
                        isUgc = "1";
                    }
                    resourceCenterService.go(url, {
                        // modalid: "37",
                        nodeid: nodeId,
                        parentid: classify.ID,
                        nodename: item.dictName || item.CATEGORYNAME,
                        change: Math.random(0, 1) * 100,
                        isugc: isUgc == "1" ? "1" : "0"
                    });
                    scope.status.selectedItem = item;
                }
                scope.selectItem = selectItem;
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        usualList: []
                    };
                    scope.data = {

                    };
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    $timeout(function() {
                            initLocation();
                    }, 600);
                    // queryMyCustoms();
                }

                /**
                 * [autoLocation 自动定位]
                 * @return {[type]} [description]
                 */
                function autoLocation(){
                    var flag = false;
                    for (var i in scope.classify) {
                        var classify = scope.classify[i];
                        if (classify.CHILDLIST.length > 0) {
                            selectItem("", classify.CHILDLIST[0], classify);
                            classify.isOpen = true;
                            flag = true;
                            break;
                        }
                    }
                    // if (!flag) {
                    //     modalDialog.alertType('info')
                    // }
                }
                /**
                 * [initLocation description] 初始化定位
                 * @return {[type]} [description]
                 */
                function initLocation() {
                    if (!resourceCenterService.hasNavigationMemory("materials", scope)) {
                        // selectItem("", scope.classify[0].CHILDLIST[0], scope.classify[0]);
                        // scope.classify[0].isOpen = true;
                        $timeout(function(){
                            autoLocation();
                        }, 1000);
                    } else {
                        $timeout(function() {
                            initSelectClassify();
                        }, 1000);
                    }
                }
                /**
                 * [getSelectedClassify description] 初始化分类
                 * @param {object} [classify] [description] 分类
                 * @return {[type]} [description]
                 */
                function initSelectClassify() {
                    for (var i in scope.classify) {
                        var classify = scope.classify[i];
                        if (classify.ID === $stateParams.parentid) {
                            classify.isOpen = true;
                            scope.status.parentNode = classify;
                            break;
                        }
                    }
                    if (scope.status.parentNode) {
                        for (var j in scope.status.parentNode.CHILDLIST) {
                            var child = scope.status.parentNode.CHILDLIST[j];
                            if (child.ID === $stateParams.nodeid) {
                                scope.status.selectedItem = child;
                                break;
                            }
                        }
                    } else {
                        selectItem("", scope.classify[0].CHILDLIST[0], scope.classify[0]);
                        scope.classify[0].isOpen = true;
                    }
                }
                /**
                 * [checkUsual description] 检查常用
                 * @param  {[type]} item [description] 被检查项
                 * @return {[type]}      [description]
                 */
                scope.checkUsual = function(item) {
                    for (var i = 0; i < scope.status.usualList.length; i++) {
                        var theItem = scope.status.usualList[i];
                        if (theItem.CUSTOMID === item.ID) {
                            return "active icon-planresource_resourc9";
                        }
                    }
                };
                
            }
        };
    }]);